<script lang="ts">
export interface ProseH1Props {
  id?: string
  class?: any
}

export interface ProseH1Slots {
  default: (props?: object) => unknown
}
</script>

<script setup lang="ts">
const props = defineProps<ProseH1Props>()
defineSlots<ProseH1Slots>()
</script>

<template>
  <h1
    :id
    :class="props.class"
    class="mb-4 mt-10 text-3xl font-semibold"
  >
    <slot />
  </h1>
</template>
